import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-900" }
const _hoisted_2 = { class: "relative isolate overflow-hidden pt-14 bg-hero" }
const _hoisted_3 = { class: "max-w-7xl px-6 lg:px-12" }
const _hoisted_4 = { class: "max-w-2xl py-32 sm:py-48 lg:py-52" }
const _hoisted_5 = { class: "text-left relative pt-36 md:pt-0" }

import AddressSearch from './AddressSearch.vue';
import Container from './Container.vue';
import { ref } from 'vue';
import { CheckIcon, Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline';
import { Dialog, DialogPanel } from '@headlessui/vue';
import { Address } from '@/adapters/autocompleteAddressAdapterInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';


export default /*@__PURE__*/_defineComponent({
  __name: 'Hero1',
  props: {
    autocompletedAddresses: {},
    address: {}
  },
  emits: ["onCheckAddressClicked", "onAddressSearchInputted", "onAutocompletedAddressClicked"],
  setup(__props: any, { emit: __emit }) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const emit = __emit;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80",
        "aria-hidden": "true"
      }, [
        _createElementVNode("div", {
          class: "relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]",
          style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hidden sm:mb-8 sm:flex sm:justify-start" }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-balance md:text-5xl font-benzin tracking-normal text-white text-3xl md:pt-0 pt-6" }, [
              _createTextVNode("HERE. NOW. "),
              _createElementVNode("span", { class: "text-black font-benzin-black" }, "ON.")
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-8 text-pretty md:text-lg font-poppins text-white text-16 leading-5 md:leading-normal max-w-sm" }, "Welcome to Nexee. Now you can thrive and live an easier life, thanks to our high-speed, reliable broadband. Discover your options today.", -1)),
            _createVNode(AddressSearch, {
              "autocompleted-addresses": _ctx.autocompletedAddresses,
              address: _ctx.address,
              onOnAutocompletedAddressClicked: _cache[0] || (_cache[0] = (address) => emit('onAutocompletedAddressClicked', address)),
              onOnCheckAddressClicked: _cache[1] || (_cache[1] = (address, done) => emit('onCheckAddressClicked', address, done)),
              onOnAddressSearchInputted: _cache[2] || (_cache[2] = (address) => emit('onAddressSearchInputted', address))
            }, null, 8, ["autocompleted-addresses", "address"])
          ])
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "hidden lg:block absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]",
        "aria-hidden": "true"
      }, [
        _createElementVNode("div", {
          class: "relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]",
          style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
        })
      ], -1))
    ])
  ]))
}
}

})